import type { AccessRule } from '../model/access-rule';

const checkRules = (itemRule: AccessRule, currentRules: string[]) => {
  if (itemRule) {
    if (itemRule.list.length === 0) {
      return true;
    }
    if (itemRule.exact) {
      return itemRule.list.every((x) => currentRules?.includes(x));
    }

    return itemRule.list.some((x) => currentRules?.includes(x));
  }
  return true;
};
export { checkRules };